import React,{useMemo} from "react";
import { styled } from "@mui/material/styles";
import { Paper, Typography, Box } from "@mui/material";
import { isBeachItem, isRestItem } from "../../assets/1menu1";
import { useMyContext } from "../../MyContext";
import { MdBeachAccess } from "react-icons/md";
import { useTranslation } from "react-i18next";
import Icon from "./Icon";

const StyledMenuItem = styled(Paper)(({ theme }) => ({
  margin: "auto",
  position: "relative",
  padding: theme.spacing( 3 ),
  zIndex: 22,
  display: "flex",
  justifyContent: "center",
  transition: "transform 0.3s, box-shadow 0.3s",
  transform: "scale(1.02)",
  backgroundColor: theme.palette.secondary.light,
  boxShadow: `
    0px 4px 0px 0px ${theme.palette.primary.main},  
    0px 0px 0px 0px ${theme.palette.primary.main}  
  `,
}));
const Overlay1 = styled("div")(({ theme }) => ({
  position: "absolute",
  zIndex: 2,
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundImage: `url("/logos/olive/1.png")`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
}));
const Overlay2 = styled("div")(({ theme }) => ({
  position: "absolute",
  zIndex: 2,
  bottom: 0,
  right: 0,
  width: "100%",
  height: "100%",
  backgroundImage: `url("/logos/olive/2.png")`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
}));
const MenuImage = styled("img")(({ theme }) => ({
  maxWidth: "50%",
  // minWidth: "50%",
  height: "auto",
  borderRadius: "50%",
  float: "left",
  border: `2px solid ${theme.palette.secondary.main}`,
}));

const MenuContent = styled("div")(({ theme }) => ({
  // marginLeft: theme.spacing(1),
  position: "relative",
}));

const MenuTitle = styled(Typography)(({ theme }) => ({
  paddingRight: theme.spacing(0),
  fontSize: "22px",
  // background: theme.palette.secondary.main,
  position: "relative",
  zIndex: 1,
  fontWeight: 700,
  color: theme.palette.text.light,
  lineHeight: "23px",
  transition: "color 0.3s",
  "&:hover": {
    color: theme.palette.text.green,
  },
}));

const MenuPrice = styled("p")(({ theme }) => ({
  // background: theme.palette.secondary.main,
  position: "relative",
  fontSize: "22px",
  zIndex: 1,
  margin: theme.spacing(1, 0),
  fontWeight: 600,
  color: theme.palette.text.light,
  "&:hover": {
    color: theme.palette.primary.main,
  },
}));

const MenuIngredients = styled("div")(({ theme }) => ({
  // fontStyle: "italic",
  // marginLeft: theme.spacing(2),
  color: theme.palette.text.light,
  fontSize: "1.3rem",
  marginTop: theme.spacing(1),
}));

const MenuItemComponent = ({ item, menu }) => {
  const { onlyMenuFromParams } = useMyContext();
  const isBeach = isBeachItem(item.id);
  const isRest = isRestItem( item.id );
  const { t} = useTranslation();

 // Memoize the calculation of englishItem
 const englishItem = useMemo(() => {
  return menu
    .find((langObj) => langObj.langKey === "en")
    ?.items.find((menuItem) => menuItem.id === item.id);
}, [menu, item]);

  const defaultImageSrc = "/menu/photo.jpg";

  // Check if we need to render the beach menu specific item
  if (onlyMenuFromParams == 2)
    if (isBeach) {
      return (
        <StyledMenuItem
          sx={{
            justifyContent: englishItem.image ? "space-between" : "center",
     
          }}
        >
          <Overlay1 />   
          {englishItem.image && (
            <MenuImage
              src={englishItem?.image || defaultImageSrc}
              alt={item.title || englishItem?.title}
            />
          )}
          <MenuContent>
            <MenuTitle>{item.title || englishItem?.title}</MenuTitle>
            <MenuPrice>
              €{englishItem?.beachPrice || englishItem?.price}
            </MenuPrice>
            <MenuIngredients>
              {item.ingredients || englishItem.ingredients}
            </MenuIngredients>
            {isBeach && !isRest && (
              <Icon url="/icons/beach-menu7.png" text="Only Beach menu Item" />
            )}
            {isRest && !isBeach && (
              <Icon
                url="/icons/rest-menu1.png"
                text="Only Restaurant menu Item"
              />
            ) }
             
          </MenuContent>
          <Box position="absolute"  top={8}
  right={8} >   <Typography sx={{fontSize:10, color: "white"}}>
        №{ item.id }
      </Typography>
    </Box>
        </StyledMenuItem>
      );
    } else return null;
  // } else if () {
  // Render all items if onlyMenuFromParams is not 2
  return (
    <StyledMenuItem
      sx={{
        justifyContent: englishItem?.image ? "space-between" : "center",
      }}
    >
      <Overlay1 />
      {englishItem?.image && (
        <MenuImage
          src={englishItem.image || defaultImageSrc}
          alt={item.title || englishItem.title}
        />
      )}
      <MenuContent>
        <MenuTitle>{item.title || englishItem.title}</MenuTitle>
        {onlyMenuFromParams == 2 ? (
          <MenuPrice>€{englishItem?.price}</MenuPrice>
        ) : (
          <MenuPrice>€{englishItem?.price}</MenuPrice>
        )}
        <MenuIngredients>
          {item.ingredients || englishItem.ingredients}
        </MenuIngredients>

        {isBeach && !isRest && (
          <Icon url="/icons/beach-menu7.png" text={t("menuItem.onlybeach")} />
        )}
        {isRest && !isBeach && (
          <Icon url="/icons/rest-menu1.png" text={t("menuItem.onlyrest")}/>
        )}
      </MenuContent>
      <Box position="absolute"  top={8}
  right={8} >   <Typography sx={{fontSize:10, color: "white"}}>
        №{ item.id }
      </Typography>
    </Box>
    </StyledMenuItem>
  
  );
}

// Wrap the component with React.memo and set a display name
const MemoizedMenuItemComponent = React.memo(MenuItemComponent);
MemoizedMenuItemComponent.displayName = 'MenuItemComponent';

export default MemoizedMenuItemComponent;
